module.exports = __webpack_public_path__ + "img/blueprints-blue.21413ecb.png";